export const smtpCredentialsTestReason = {
  hostNotAllowed: 'host_not_allowed',
  hostUnresolvable: 'host_unresolvable',
  connectionTimedOut: 'connection_timed_out',
  connectionFailed: 'connection_failed',
  startTlsFailed: 'start_tls_failed',
  tlsUnavailable: 'tls_unavailable',
  authenticationFailed: 'authentication_failed',
  unexpectedError: 'unexpected_error',
} as const;
